export default function hydrateRecentSearchesActionCreator(recentSearchDuck, personalization) {
  return function (_temp) {
    let {
      withCounts = false
    } = _temp === void 0 ? {} : _temp;
    return async dispatch => {
      try {
        let searches = await personalization.refreshInventorySearchCache();
        personalization.setInventorySearchCache(searches);
        if (withCounts) {
          searches = searches.filter(search => search.totalResultCount !== 0);
        }
        if (searches) {
          dispatch({
            type: recentSearchDuck.types.SET_RECENT_SEARCHES,
            payload: searches
          });
        }
        return searches;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      return [];
    };
  };
}